import "./App.css";
import Footer from "./Component/Footer";
import Header from "./Component/Header";
import BlogsPage from "./Pages/BlogsPage";
import HomePage from "./Pages/HomePage";
import NotFoundPage from "./Pages/NotFoundPage";
import { Routes, Route } from "react-router-dom";
import BlogDetailsPage from "./Pages/BlogDetailsPage";
import ScrollToHash from "./ProtectedRoutes/ScrollToHash";
import { HelmetProvider } from 'react-helmet-async';

function App() {

  return (
    <HelmetProvider>
      <div className="App bg-background-light dark:bg-background-dark text-[#0d121b] dark:text-[#e0e0e0] font-sans antialiased selection:bg-primary/20 selection:text-primary">
        <ScrollToHash />
        <Header />
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/blog" element={<BlogsPage />} />
          <Route path="/blog/:slug" element={<BlogDetailsPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
        <Footer />
      </div>
    </HelmetProvider>
  );
}

export default App;
